// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__26CRy","overflowing":"ReadFullNote_overflowing__DXVLg"};